import { Navigate, useLocation } from "react-router-dom";

export default function RequireAuth({ children }) {
  const location = useLocation();

  // ? Single source of truth (backend-aligned)
  const userId = localStorage.getItem("userId");

  // ? Not logged in
  if (!userId) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location }}
      />
    );
  }

  // ? Logged in
  return children;
}
